// extracted by mini-css-extract-plugin
export var emailBlockLink = "_j4-0";